<template>
    <span>
        <el-form-item :label="label" class="ss-view-item">
            <span>{{valueInput?valueInput:''}} </span>       
           <span>{{unit}} </span> 
        </el-form-item>         
    </span>
</template>

<script>
export default { 
    data(){
        return{          
            valueInput:this.objInput,
            unit:""
        }
    },
    props:{  
        objInput: {
            type: String
        },  
        label:{
            type:String,
        },
        tprop:{
            type:Object
        }
    },
    watch: {
        objInput(newVal,oldVal){         
           if (newVal !== oldVal) {
                this.valueInput = newVal;
            }
        },
        tprop: {
            handler(newVal,oldVal) {
                if(newVal!=oldVal){
                    this.getUnit();
                } 
                
            },
            immediate: true,
            deep: true
        },
    },
     created(){
        this.getUnit();
    },
    methods:{
        getUnit:function(){
            let b = false;
            if(this.tprop){
                if(this.tprop.rules && this.tprop.rules.length>0){
                    let rules = JSON.parse(this.tprop.rules);
                    let unit = rules.unit ;
                    this.unit = unit;
                    b = true;
                }                
            }
            if(!b){
                this.unit="";
            }
        }
    }

}
</script>
<style lang="scss" >

 
</style>